/* Exposition des liens d’avis — RJ-04 (Bible §26.1 · MER-85 · D-63 for the name).
   Rotation is deliberate, not accidental. The exposure ledger records
   assigned / shown / opened per customer — never « completed review », which
   the product cannot know. Suppressed Destinations are excluded before
   assignment and the remaining shares renormalise. */
import { Button, ErrorState, KV, Note } from '@/ui'
import { useExposure } from './api'
import { Chargement, Retour } from './parts'

export default function Exposition() {
  const { data, isPending, isError, refetch } = useExposure()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger l’exposition."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 760 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Exposition des liens d’avis</h2>

      <KV rows={[['Fréquence globale des invitations publiques',
        <span key="f"><b>{data.publicFrequencyDays} jours</b> par client</span>]]} />

      <div className="tablewrap">
        <table className="tbl">
          <thead><tr><th>Lien d’avis</th><th>Fenêtre propre</th><th>Priorité de repli</th></tr></thead>
          <tbody>
            {data.rows.map(r => (
              <tr key={r.destination}>
                <td>{r.destination}</td>
                <td>{r.ownWindow}</td>
                <td>{r.priority}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Note tone="ok">
        Résultat&nbsp;: Google à une visite, Trustpilot plus tard, PagesJaunes ensuite —
        jamais Google en boucle par hasard. Si tout est en fenêtre&nbsp;: quiz, retour privé
        ou cadeau seul.
      </Note>
    </div>
  )
}
